// extracted by mini-css-extract-plugin
export var actionButton = "_mt-0";
export var actionMenuContainer = "_mt-i";
export var bubble = "_mt-2";
export var bubbleActionMenu = "_mt-j";
export var bubbleContext = "_mt-6";
export var bubbleItems = "_mt-7";
export var customer = "_mt-3";
export var divider = "_mt-8";
export var fileList = "_mt-9";
export var hiddenComment = "_mt-o";
export var infoAbove = "_mt-a";
export var internal = "_mt-4";
export var lightActionButton = "_mt-1";
export var link = "_mt-b";
export var merchant = "_mt-5";
export var message = "_mt-c";
export var profilePicture = "_mt-e";
export var quillToolbarContainer = "_mt-f";
export var senderDate = "_mt-g";
export var senderDateCustomer = "_mt-h";
export var senderName = "_mt-d";
export var time = "_mt-k";
export var uploadedImage = "_mt-l";
export var username = "_mt-m";
export var xsmall = "_mt-n";